'use client';

import { RefObject } from 'react';
import { clsx } from 'clsx';

import { SharedLink } from '@monoimin/atoms';
import { AnalyticsClickProvider } from '@monoimin/analytics';

import type { LinkStoryblok } from '@monoimin/sb-types';

const sanitizeUrl = (url?: string): string => {
  if (!url) return '';
  return url.replace(/\//g, '');
};

type HeaderContentProps = {
  links: Array<LinkStoryblok>;
  className?: string;
  fixedHeader: boolean;
  hideHeader: boolean;
  scrollContainerRef: RefObject<HTMLDivElement>;
};

export const HeaderContent = ({
  links,
  className,
  fixedHeader,
  hideHeader,
  scrollContainerRef,
}: HeaderContentProps) => {
  return (
    <div
      className={clsx(
        className,
        'w-full h-14 bg-blueGrey flex items-center z-[25] duration-200 ease-in-out',
        fixedHeader ? clsx('sticky-header_active fixed top-16') : '',
        hideHeader ? '-translate-y-14' : 'translate-y-0'
      )}
    >
      <nav
        ref={scrollContainerRef}
        className='container flex overflow-x-scroll scrollbar-hide relative'
      >
        <ul className='flex gap-4 md:gap-10 h-14 items-center relative'>
          {links.map((item) => {
            const { _uid, link } = item;

            if (link) {
              const { title, url } = link;

              const href = sanitizeUrl(url);

              return (
                <AnalyticsClickProvider
                  key={_uid}
                  as='li'
                  categoryType='Program table-of-contents'
                  action='program_table_of_contents_click'
                  sendToRenta
                  className='border-b-2 border-transparent sm:hover:border-black-200 duration-150 h-full items-center flex'
                >
                  <SharedLink
                    href={href}
                    underline='off'
                    className='body-small whitespace-nowrap'
                  >
                    {title}
                  </SharedLink>
                </AnalyticsClickProvider>
              );
            }

            return null;
          })}
        </ul>
      </nav>
    </div>
  );
};
